import { MailWarning } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { authClient } from "@/lib/auth";

// Email/password users who haven't verified their address can't link a Google
// sign-in to their account, so ask them to verify.
export default function VerifyEmailNudge() {
    const { data: session } = authClient.useSession();
    const [status, setStatus] = useState<"idle" | "sending" | "sent">("idle");

    if (!session?.user || session.user.emailVerified) {
        return null;
    }

    const sendVerificationEmail = async () => {
        setStatus("sending");
        const { error } = await authClient.sendVerificationEmail({ email: session.user.email });
        if (error) {
            setStatus("idle");
            toast.error(error.message || "Couldn't send the verification email. Please try again.");
            return;
        }
        setStatus("sent");
    };

    return (
        <div className="bg-slate-500/70 text-white ml-2 mb-2 p-2 rounded-sm flex items-start gap-2">
            <MailWarning className="size-4.5 shrink-0" />
            {status === "sent" ? (
                <div>Check your inbox at {session.user.email} for the verification link.</div>
            ) : (
                <div>
                    Please verify your email address.{" "}
                    <button
                        type="button"
                        onClick={sendVerificationEmail}
                        disabled={status === "sending"}
                        className="font-medium underline-offset-2 hover:underline disabled:opacity-70"
                    >
                        {status === "sending" ? "Sending…" : "Resend verification email"}
                    </button>
                </div>
            )}
        </div>
    );
}
